export default __webpack_public_path__ + "static/video-23d91b8e7e976e80d033c4980a22e1eb.png";